class Department {
	constructor(instance) {
		this.axios = instance
	}

	/**
	 * 부서 드롭다운 옵션 목록.
	 * @param {'DUTY'|'TEST'|undefined} kind  undefined=전체
	 * @returns {{ options: Array<{ id, kind, value, text, label, category, sortOrder }> }}
	 */
	async getOptions(kind) {
		const path = kind ? `/department/options/${kind}` : '/department/options'
		const response = await this.axios.get(path)
		return response.data
	}
}

export default Department
